import { PageLayoutDefaultMenuNavigationLinkItem } from "@sis/react-library";
import { RouteObject } from "react-router-dom";
import StadiumIcon from '@mui/icons-material/Stadium';
import { TrackPage } from "./trackPage/TrackPage";
import { hasAdminRole } from "../../utils/authenticationUtils";
import { TrackEditPage } from "./trackEditPage/TrackEditPage";
import { TrackNewPage } from "./trackNewPage/TrackNewPage";

const url = "track";

// use in same file
// eslint-disable-next-line
export const trackRoutes = {
    main: `/${url}`,

    new: 'new',
    edit: 'edit/',

    match: ":key",
}

// use in same file
// eslint-disable-next-line
export const trackRoutesCombined = {
    new: `${trackRoutes.main}/${trackRoutes.new}`,
    edit: `${trackRoutes.main}/${trackRoutes.edit}`,
    editMatch: `${trackRoutes.main}/${trackRoutes.edit}${trackRoutes.match}`,
}

export const TrackNavigation = (): RouteObject[] => {
    // Manage track codes only for admins
    return hasAdminRole() ?
        [
            {
                path: trackRoutes.main,
                element: <TrackPage />,
                children: [
                    {
                        path: `${trackRoutes.new}`,
                        element: <TrackNewPage />
                    },
                    {
                        path: `${trackRoutes.edit}${trackRoutes.match}`,
                        element: <TrackEditPage />
                    }
                ]
            }
        ] :
        []
}

export const TrackMenuItems = (): PageLayoutDefaultMenuNavigationLinkItem[] =>
    // Manage track codes only for admins
    hasAdminRole() ?
        [{ icon: <StadiumIcon />, text: 'Track Codes', navigateTo: trackRoutes.main }] :
        []
